import { InjectionToken } from '@angular/core';

// Domain-specific injection tokens for API base paths
export const AUDIT_API_BASE_PATH = new InjectionToken<string>('auditApiBasePath');
export const USERS_API_BASE_PATH = new InjectionToken<string>('usersApiBasePath');
export const COMPANIES_API_BASE_PATH = new InjectionToken<string>('companiesApiBasePath');
export const SALES_API_BASE_PATH = new InjectionToken<string>('salesApiBasePath');
export const LOCATIONS_API_BASE_PATH = new InjectionToken<string>('locationsApiBasePath');
export const BRANDS_API_BASE_PATH = new InjectionToken<string>('brandsApiBasePath');
export const VENDORS_API_BASE_PATH = new InjectionToken<string>('vendorsApiBasePath');
export const CURRENCIES_API_BASE_PATH = new InjectionToken<string>('currenciesApiBasePath');
export const CUSTOMERS_API_BASE_PATH = new InjectionToken<string>('customersApiBasePath');
export const DOCUMENTS_API_BASE_PATH = new InjectionToken<string>('documentsApiBasePath');
export const FINANCE_API_BASE_PATH = new InjectionToken<string>('financeApiBasePath');
export const INFRASTRUCTURE_API_BASE_PATH = new InjectionToken<string>('infrastructureApiBasePath');
export const INVENTORY_API_BASE_PATH = new InjectionToken<string>('inventoryApiBasePath');
export const SIGNALR_API_BASE_PATH = new InjectionToken<string>('signalRApiBasePath');
export const NOTIFICATIONS_API_BASE_PATH = new InjectionToken<string>('notificationsApiBasePath');
export const PRODUCT_CATALOGUE_API_BASE_PATH = new InjectionToken<string>(
    'productCatalogueApiBasePath'
);
export const SCHEDULER_API_BASE_PATH = new InjectionToken<string>('schedulerApiBasePath');
export const SETTINGS_API_BASE_PATH = new InjectionToken<string>('settingsApiBasePath');
export const SUBSCRIPTIONS_API_BASE_PATH = new InjectionToken<string>('subscriptionsApiBasePath');
export const TASKS_API_BASE_PATH = new InjectionToken<string>('tasksApiBasePath');
export const DEVICES_API_BASE_PATH = new InjectionToken<string>('devicesApiBasePath');
export const TAX_API_BASE_PATH = new InjectionToken<string>('taxApiBasePath');
export const CONTACTS_API_BASE_PATH = new InjectionToken<string>('contactsApiBasePath');
export const REPORTING_API_BASE_PATH = new InjectionToken<string>('reportingApiBasePath');
export const MANUFACTURING_API_BASE_PATH = new InjectionToken<string>('manufacturingApiBasePath');
export const VERIFIED_API_BASE_PATH = new InjectionToken<string>('verifiedApiBasePath');
export const WORKFLOWS_API_BASE_PATH = new InjectionToken<string>('workflowsApiBasePath');
export const WORK_OS_CATALOG_API_BASE_PATH = new InjectionToken<string>('workOsCatalogApiBasePath');
export const WORK_MANAGEMENT_API_BASE_PATH = new InjectionToken<string>(
    'workManagementApiBasePath'
);
export const PROJECTS_API_BASE_PATH = new InjectionToken<string>('projectsApiBasePath');
export const PURCHASE_API_BASE_PATH = new InjectionToken<string>('purchaseApiBasePath');

// API Domain mapping type
export interface ApiDomainMapping {
    audit: string;
    users: string;
    companies: string;
    sales: string;
    locations: string;
    brands: string;
    vendors: string;
    currencies: string;
    customers: string;
    documents: string;
    finance: string;
    infrastructure: string;
    inventory: string;
    notifications: string;
    productCatalogue: string;
    reporting: string;
    scheduler: string;
    settings: string;
    subscriptions: string;
    tasks: string;
    tax: string;
    contacts: string;
    manufacturing: string;
    verified: string;
    workflows: string;
    workOsCatalog: string;
    workManagement: string;
    projects: string;
    purchase: string;
}
